import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FillWidthCell from '../../../../../app/components/FillWidthCell';

export const MenuHeader = React.memo(() => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell width="50px" align="left" />
      <TableCell width="50px" align="left">
        #
      </TableCell>
      <FillWidthCell align="left">{t('menu.list.header.title')}</FillWidthCell>
      <TableCell align="right" />
    </TableRow>
  );
});

MenuHeader.displayName = 'MenuHeader';
